import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class ColorService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 491 */
    public getHexColors(): Promise<HexColorItem[]> { return this.datatask.Post(491, {}); }
}
export interface HexColorItem { hexcolor: string; color_name: string; }
